import {
  uploadDataUriToCloudflareUrl,
  uploadFileToCloudflareUrl,
} from '../../utils/uploadUtils';

export function fileToDataURI(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    try {
      const fileReader = new FileReader();
      fileReader.onload = () => resolve(fileReader.result as string);
      fileReader.readAsDataURL(file);
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}

export function dataURItoBlob(dataURI: string) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  var ia = new Uint8Array(ab);

  // set the bytes of the buffer to the correct values
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  var blob = new Blob([ab], { type: mimeString });
  return blob;
}

export async function defaultFileUploader(
  file,
  _id?: string,
  options: any = { convertToWebp: false }
) {
  return uploadFileToCloudflareUrl(file, undefined, options);
}

/** Upload a data-URL image via Cloudflare Images (direct upload). Kept name for legacy imports. */
export async function uploadDataUrlToS3(
  dataUri,
  _id?: string,
  options: any = { convertToWebp: false }
) {
  return uploadDataUriToCloudflareUrl(dataUri, undefined, options);
}
